import React, { Component } from 'react'
import "./chatbot.scss";

export default class chatbot extends Component {
    chatbotBtn = () =>{
        document.getElementById("chatbot").classList.toggle("activeChatbot");
    
      };
    render() {
        return (
       
                        <div className="chatbot">
          <img onClick={this.chatbotBtn} src={require("../../images/chatbot-icon.png")} alt="" />
          <iframe
            id="chatbot"
            className=""
            width="350"
            height="430"
            allow="microphone;"
            src="https://console.dialogflow.com/api-client/demo/embedded/b9db80e1-b9ae-405d-86c5-2e5e7bdc4dc4"
          ></iframe>
        </div>
         
        )
    }
}
